import React, { memo } from 'react'

import { number, oneOf, string } from 'prop-types'

import i18n from 'Pods/Shared/I18nThreeDStudio'

import CheckIcon from '../CheckIcon/CheckIcon'

const VARIANT_CONFIG = {
  subscription: {
    listClass: 'usage-modal__bullets',
    itemClass: 'usage-modal__bullet',
    iconSize: 'small',
  },
  upgrade: {
    listClass: 'usage-modal__upgrade-card-bullets',
    itemClass: 'usage-modal__upgrade-card-bullet',
    iconSize: 'small',
  },
}

// Subscription benefit list shared by the 3D Studio usage modal and the AI subscription landing
// waitlist modal. monthlyModels is injected by the caller (the studio reads it from its store, the
// landing passes a literal) so the component stays store-agnostic. locale is passed in (not read
// from context) so the component stays usable outside the studio page.
function SubscriptionBullets({ variant, monthlyModels = null, locale = 'en' }) {
  const { listClass, itemClass, iconSize } = VARIANT_CONFIG[variant]

  const t = (key, options) => i18n.t(key, { ns: 'three-d-studio', lng: locale, ...options })

  return (
    <ul className={listClass}>
      {monthlyModels != null && (
        <li className={itemClass}>
          <CheckIcon size={iconSize} />
          <span className="cgt-body-base">
            {t('waitlist.subscriptionBullets.monthly', { monthlyModels })}
          </span>
        </li>
      )}
      <li className={itemClass}>
        <CheckIcon size={iconSize} />
        <span className="cgt-body-base">
          {t('waitlist.subscriptionBullets.editEnhance')}
        </span>
      </li>
      <li className={itemClass}>
        <CheckIcon size={iconSize} />
        <span className="cgt-body-base">{t('waitlist.subscriptionBullets.engines')}</span>
      </li>
    </ul>
  )
}

SubscriptionBullets.propTypes = {
  variant: oneOf(['subscription', 'upgrade']).isRequired,
  monthlyModels: number,
  locale: string,
}

export default memo(SubscriptionBullets)
